import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import ProductCard from '../../product-catalog/components/ProductCard';

const PeptidesByCategory = () => {
  const navigate = useNavigate();

  const allProducts = [
  {
    id: 1,
    name: "Tirzepatide 10mg",
    category: "Weight Management",
    price: 73.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 50,
    rating: 4.9,
    reviews: 156,
    isNew: true,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b979c835-1770289791766.png",
    imageAlt: "Tirzepatide 10mg peptide vial for weight management and blood sugar regulation"
  },
  {
    id: 2,
    name: "Tirzepatide 15mg",
    category: "Weight Management",
    price: 109.00,
    originalPrice: null,
    dosage: "15mg",
    brand: "INF LABS",
    stock: 45,
    rating: 4.9,
    reviews: 142,
    isNew: true,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1151f3b4f-1770505606283.png",
    imageAlt: "Tirzepatide 15mg peptide vial for advanced weight management"
  },
  {
    id: 3,
    name: "Tirzepatide 20mg",
    category: "Weight Management",
    price: 146.00,
    originalPrice: null,
    dosage: "20mg",
    brand: "INF LABS",
    stock: 38,
    rating: 4.8,
    reviews: 98,
    isNew: false,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b979c835-1770289791766.png",
    imageAlt: "Tirzepatide 20mg peptide vial for weight loss and metabolic health"
  },
  {
    id: 4,
    name: "Tirzepatide 30mg",
    category: "Weight Management",
    price: 250.00,
    originalPrice: null,
    dosage: "30mg",
    brand: "INF LABS",
    stock: 32,
    rating: 4.9,
    reviews: 87,
    isNew: false,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_105ce3fbf-1766470445165.png",
    imageAlt: "Tirzepatide 30mg peptide vial for maximum weight management support"
  },
  {
    id: 5,
    name: "Tirzepatide 60mg",
    category: "Weight Management",
    price: 437.00,
    originalPrice: null,
    dosage: "60mg",
    brand: "INF LABS",
    stock: 25,
    rating: 4.9,
    reviews: 64,
    isNew: true,
    keyBenefits: "Significant weight loss support • Blood sugar regulation • Cardiovascular health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_11ad0f3e7-1770506966609.png",
    imageAlt: "Tirzepatide 60mg peptide vial for comprehensive metabolic support"
  },
  {
    id: 6,
    name: "Retatrutide (Reta) 6mg",
    category: "Weight Management",
    price: 46.00,
    originalPrice: null,
    dosage: "6mg",
    brand: "INF LABS",
    stock: 60,
    rating: 4.8,
    reviews: 112,
    isNew: true,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17d15b47e-1770505604842.png",
    imageAlt: "Retatrutide 6mg peptide vial with triple-action weight management formula"
  },
  {
    id: 7,
    name: "Retatrutide (Reta) 10mg",
    category: "Weight Management",
    price: 77.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 55,
    rating: 4.9,
    reviews: 134,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b979c835-1770289791766.png",
    imageAlt: "Retatrutide 10mg peptide vial for metabolic health enhancement"
  },
  {
    id: 8,
    name: "Retatrutide (Reta) 12mg",
    category: "Weight Management",
    price: 92.00,
    originalPrice: null,
    dosage: "12mg",
    brand: "INF LABS",
    stock: 48,
    rating: 4.8,
    reviews: 98,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1aa868f6e-1770507423497.png",
    imageAlt: "Retatrutide 12mg peptide vial for advanced metabolic support"
  },
  {
    id: 9,
    name: "Retatrutide (Reta) 20mg",
    category: "Weight Management",
    price: 140.00,
    originalPrice: null,
    dosage: "20mg",
    brand: "INF LABS",
    stock: 42,
    rating: 4.9,
    reviews: 87,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b01e08d-1770505606100.png",
    imageAlt: "Retatrutide 20mg peptide vial for potent weight management"
  },
  {
    id: 10,
    name: "Retatrutide (Reta) 24mg",
    category: "Weight Management",
    price: 184.00,
    originalPrice: null,
    dosage: "24mg",
    brand: "INF LABS",
    stock: 35,
    rating: 4.8,
    reviews: 76,
    isNew: true,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1486a5da7-1770505607312.png",
    imageAlt: "Retatrutide 24mg peptide vial for comprehensive weight management"
  },
  {
    id: 11,
    name: "Retatrutide (Reta) 30mg",
    category: "Weight Management",
    price: 170.00,
    originalPrice: null,
    dosage: "30mg",
    brand: "INF LABS",
    stock: 30,
    rating: 4.9,
    reviews: 65,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10e34c02d-1770506962626.png",
    imageAlt: "Retatrutide 30mg peptide vial for maximum metabolic support"
  },
  {
    id: 12,
    name: "Retatrutide (Reta) 48mg",
    category: "Weight Management",
    price: 367.00,
    originalPrice: null,
    dosage: "48mg",
    brand: "INF LABS",
    stock: 22,
    rating: 4.9,
    reviews: 54,
    isNew: true,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1dbc0cba8-1770505605861.png",
    imageAlt: "Retatrutide 48mg peptide vial for intensive weight management"
  },
  {
    id: 13,
    name: "Retatrutide (Reta) 60mg",
    category: "Weight Management",
    price: 252.00,
    originalPrice: null,
    dosage: "60mg",
    brand: "INF LABS",
    stock: 18,
    rating: 4.8,
    reviews: 48,
    isNew: false,
    keyBenefits: "Potent weight management • Metabolic health support • Triple-action mechanism",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a864c8bc-1770506960880.png",
    imageAlt: "Retatrutide 60mg peptide vial for comprehensive metabolic health"
  },
  {
    id: 14,
    name: "BPC-157 10mg",
    category: "Recovery & Healing",
    price: 32.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 65,
    rating: 4.9,
    reviews: 234,
    isNew: false,
    keyBenefits: "Accelerates tissue & wound healing • Reduces inflammation • Supports gut health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12d63bcd9-1764699716363.png",
    imageAlt: "BPC-157 10mg peptide vial for tissue healing and recovery"
  },
  {
    id: 15,
    name: "GHK-Cu 100mg",
    category: "Recovery & Healing",
    price: 77.00,
    originalPrice: null,
    dosage: "100mg",
    brand: "INF LABS",
    stock: 40,
    rating: 4.8,
    reviews: 187,
    isNew: true,
    keyBenefits: "Skin rejuvenation & collagen synthesis • Supports wound healing • Antioxidant properties",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_15332a5cb-1770506962648.png",
    imageAlt: "GHK-Cu 100mg peptide vial for skin rejuvenation and healing"
  },
  {
    id: 16,
    name: "Tesamorelin 10mg",
    category: "Performance Enhancement",
    price: 88.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 35,
    rating: 4.7,
    reviews: 92,
    isNew: false,
    keyBenefits: "Stimulates growth hormone release • May reduce visceral fat • Supports muscle recovery",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b979c835-1770289791766.png",
    imageAlt: "Tesamorelin 10mg peptide vial for growth hormone support"
  },
  {
    id: 17,
    name: "CJC-1295 / Ipamorelin Blend 10mg",
    category: "Performance Enhancement",
    price: 59.00,
    originalPrice: null,
    dosage: "10mg total",
    brand: "INF LABS",
    stock: 50,
    rating: 4.9,
    reviews: 178,
    isNew: true,
    keyBenefits: "Promotes fat loss & muscle gain • Supports recovery & sleep quality • Selective GH release",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_105b5701b-1770505605709.png",
    imageAlt: "CJC-1295 Ipamorelin Blend peptide vial for performance enhancement"
  },
  {
    id: 18,
    name: "PT-141 10mg",
    category: "Performance Enhancement",
    price: 44.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 45,
    rating: 4.6,
    reviews: 134,
    isNew: false,
    keyBenefits: "Libido enhancement in both sexes • Non-hormonal mechanism • Acts centrally in the brain",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ba759436-1770505605640.png",
    imageAlt: "PT-141 10mg peptide vial for libido enhancement"
  },
  {
    id: 19,
    name: "Sermorelin 5mg",
    category: "Performance Enhancement",
    price: 44.00,
    originalPrice: null,
    dosage: "5mg",
    brand: "INF LABS",
    stock: 55,
    rating: 4.8,
    reviews: 156,
    isNew: false,
    keyBenefits: "Stimulates natural GH production • Anti-aging & recovery support • Well-tolerated profile",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_162a4e376-1770505605879.png",
    imageAlt: "Sermorelin 5mg peptide vial for growth hormone production"
  },
  {
    id: 20,
    name: "BPC-157 / TB-4 Blend 20mg",
    category: "Recovery & Healing",
    price: 108.00,
    originalPrice: null,
    dosage: "20mg total",
    brand: "INF LABS",
    stock: 38,
    rating: 4.9,
    reviews: 201,
    isNew: true,
    keyBenefits: "Synergistic healing & repair • Reduces inflammation • Supports muscle, tendon, gut health",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ac1da7ef-1770505604694.png",
    imageAlt: "BPC-157 TB-4 Blend peptide vial for comprehensive healing"
  },
  {
    id: 21,
    name: "GHK-cu / KPV Blend 70mg",
    category: "Recovery & Healing",
    price: 257.00,
    originalPrice: null,
    dosage: "70mg total",
    brand: "INF LABS",
    stock: 25,
    rating: 4.7,
    reviews: 89,
    isNew: true,
    keyBenefits: "Skin rejuvenation & anti-inflammatory • Topical cosmetic benefits • Promotes collagen, reduces redness",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1592ac306-1770505606489.png",
    imageAlt: "GHK-cu KPV Blend peptide vial for skin health"
  },
  {
    id: 22,
    name: "Semax 10mg",
    category: "Cognitive Enhancement",
    price: 42.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 42,
    rating: 4.8,
    reviews: 167,
    isNew: false,
    keyBenefits: "Cognitive enhancement & neuroprotection • May improve mood & focus • Supports brain recovery",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12f47cced-1770507220091.png",
    imageAlt: "Semax 10mg peptide vial for cognitive enhancement"
  },
  {
    id: 23,
    name: "Ipamorelin 10mg",
    category: "Performance Enhancement",
    price: 59.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 48,
    rating: 4.8,
    reviews: 143,
    isNew: false,
    keyBenefits: "Selective GH secretagogue • Supports recovery & body composition • Minimal impact on cortisol",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ea9a56fd-1770505606785.png",
    imageAlt: "Ipamorelin 10mg peptide vial for selective growth hormone release"
  },
  {
    id: 24,
    name: "Selank 10mg",
    category: "Cognitive Enhancement",
    price: 41.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 40,
    rating: 4.7,
    reviews: 128,
    isNew: false,
    keyBenefits: "May reduce anxiety & stress • Supports cognitive function • Potential nootropic effects",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1acd229be-1770506965405.png",
    imageAlt: "Selank 10mg peptide vial for anxiety and stress support"
  },
  {
    id: 25,
    name: "AOD-9604 2mg",
    category: "Weight Management",
    price: 27.00,
    originalPrice: null,
    dosage: "2mg",
    brand: "INF LABS",
    stock: 60,
    rating: 4.6,
    reviews: 95,
    isNew: false,
    keyBenefits: "May stimulate fat metabolism • Supports weight loss • Derived from GH fragment",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1572eff40-1770506962637.png",
    imageAlt: "AOD-9604 2mg peptide vial for fat metabolism"
  },
  {
    id: 26,
    name: "Melanotan II 10mg",
    category: "Performance Enhancement",
    price: 45.00,
    originalPrice: null,
    dosage: "10mg",
    brand: "INF LABS",
    stock: 35,
    rating: 4.5,
    reviews: 112,
    isNew: false,
    keyBenefits: "Promotes skin tanning • May enhance libido • Can suppress appetite",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_136b5df99-1764679627518.png",
    imageAlt: "Melanotan II 10mg peptide vial for tanning support"
  }];



  const categories = [
  { name: 'Weight Management', icon: 'Scale' },
  { name: 'Recovery & Healing', icon: 'Heart' },
  { name: 'Performance Enhancement', icon: 'Zap' },
  { name: 'Cognitive Enhancement', icon: 'Brain' }];



  const getProductsByCategory = (categoryName) => {
    return allProducts?.filter((product) => product?.category === categoryName);
  };

  // Add this block - onAddToCart handler
  const handleAddToCart = (product) => {
    // Add to cart logic would go here
    console.log('Adding to cart:', product);
  };

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-[1440px] mx-auto">
        {/* Main Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-4">
            Explore Our Peptide Collection
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Premium pharmaceutical-grade peptides organized by category for your specific needs
          </p>
        </div>

        {/* Categories */}
        {categories?.map((category, index) => {
          const categoryProducts = getProductsByCategory(category?.name);

          if (categoryProducts?.length === 0) return null;

          return (
            <div key={index} className="mb-16">
              {/* Category Header */}
              <div className="flex items-center justify-between mb-8">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/30 flex items-center justify-center">
                    <Icon name={category?.icon} size={24} color="var(--color-primary)" />
                  </div>
                  <div>
                    <h3 className="text-2xl md:text-3xl font-bold text-foreground">
                      {category?.name}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {categoryProducts?.length} products available
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => navigate(`/product-catalog?category=${category?.name?.toLowerCase()?.replace(/\s+/g, '-')}`)}
                  className="px-6 py-3 rounded-lg bg-primary/10 border border-primary/30 text-primary font-medium hover:bg-primary/20 transition-all duration-300 flex items-center gap-2">
                  
                  VIEW ALL
                  <Icon name="ArrowRight" size={18} />
                </button>
              </div>

              {/* Products Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {categoryProducts?.slice(0, 4)?.map((product) =>
                <ProductCard key={product?.id} product={product} onAddToCart={handleAddToCart} />
                )}
              </div>
            </div>);

        })}
      </div>
    </section>);

};

export default PeptidesByCategory;